export enum AccountHistoryTypes {
  ACCOUNT_CREATED = 'ACCOUNT_CREATED',
  ACCOUNT_UPDATED = 'ACCOUNT_UPDATED',
  DISPLAY_NAME_UPDATED = 'DISPLAY_NAME_UPDATED',
  TRANSFER_METHOD_CREATED = 'TRANSFER_METHOD_CREATED',
  TRANSFER_METHOD_DEACTIVATED = 'TRANSFER_METHOD_DEACTIVATED',
}

export enum AccountStatuses {
  // Negative Statuses = Action Required
  DE_ACTIVATED = 'DE_ACTIVATED',
  FROZEN = 'FROZEN',
  LOCKED = 'LOCKED',
  PAYOUT_ERROR = 'PAYOUT_ERROR',

  // Positive Statuses
  PRE_ACTIVATED = 'PRE_ACTIVATED',
  ACTIVATED = 'ACTIVATED',
}

export enum BusinessTypes {
  CORPORATION = 'CORPORATION',
  PRIVATE_COMPANY = 'PRIVATE_COMPANY',
  PARTNERSHIP = 'PARTNERSHIP',
  NOT_FOR_PROFIT_ORGANIZATION = 'NOT_FOR_PROFIT_ORGANIZATION',
  GOVERNMENT_ENTITY = 'GOVERNMENT_ENTITY',
  PUBLIC_COMPANY = 'PUBLIC_COMPANY',
}

export enum DestinationAccountStatuses {
  // Negative Statuses = Action Required
  DE_ACTIVATED = 'DE_ACTIVATED',
  INVALID = 'INVALID',

  // Positive Statuses
  VERIFIED = 'VERIFIED',
  ACTIVATED = 'ACTIVATED',
}

export enum HyperwalletAccountTypes {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  PAYPAL_ACCOUNT = 'PAYPAL_ACCOUNT',
}

export enum HyperwalletNotificationTypes {
  USER_LOCKED = 'USERS.UPDATED.STATUS.LOCKED',
  VERIFICATION_REQUIRED = 'USERS.UPDATED.VERIFICATION_STATUS.REQUIRED',
  USER_ACCOUNT_VERIFIED = 'USERS.UPDATED.VERIFICATION_STATUS.VERIFIED',
  USERS_DE_ACTIVATED = 'USERS.UPDATED.STATUS.DE_ACTIVATED',
  USERS_ACTIVATED = 'USERS.UPDATED.STATUS.ACTIVATED',
  USERS_PRE_ACTIVATED = 'USERS.UPDATED.STATUS.PRE_ACTIVATED',

  BANK_ACCOUNTS_ACTIVATED = 'USERS.BANK_ACCOUNTS.UPDATED.STATUS.ACTIVATED',
  BANK_ACCOUNTS_CREATED = 'USERS.BANK_ACCOUNTS.CREATED',
  BANK_ACCOUNTS_DE_ACTIVATED = 'USERS.BANK_ACCOUNTS.UPDATED.STATUS.DE_ACTIVATED',
  BANK_ACCOUNTS_VERIFIED = 'USERS.BANK_ACCOUNTS.UPDATED.STATUS.VERIFIED',

  PAYPAL_ACCOUNTS_ACTIVATED = 'USERS.PAYPAL_ACCOUNTS.UPDATED.STATUS.ACTIVATED',
  PAYPAL_ACCOUNTS_CREATED = 'USERS.PAYPAL_ACCOUNTS.CREATED',
  PAYPAL_ACCOUNTS_DE_ACTIVATED = 'USERS.PAYPAL_ACCOUNTS.UPDATED.STATUS.DE_ACTIVATED',
  PAYPAL_ACCOUNTS_VERIFIED = 'USERS.PAYPAL_ACCOUNTS.UPDATED.STATUS.VERIFIED',

  VENMO_ACCOUNTS_ACTIVATED = 'USERS.VENMO_ACCOUNTS.UPDATED.STATUS.ACTIVATED',
  VENMO_ACCOUNTS_DE_ACTIVATED = 'USERS.VENMO_ACCOUNTS.UPDATED.STATUS.DE_ACTIVATED',
  VENMO_ACCOUNTS_VERIFIED = 'USERS.VENMO_ACCOUNTS.UPDATED.STATUS.VERIFIED',

  BANK_CARDS_ACTIVATED = 'USERS.BANK_CARDS.UPDATED.STATUS.ACTIVATED',
  BANK_CARDS_VERIFIED = 'USERS.BANK_CARDS.UPDATED.STATUS.VERIFIED',
  BANK_CARDS_DE_ACTIVATED = 'USERS.BANK_CARDS.UPDATED.STATUS.DE_ACTIVATED',

  PAYMENTS_COMPLETED = 'PAYMENTS.UPDATED.STATUS.COMPLETED',
  PAYMENTS_FAILED = 'PAYMENTS.UPDATED.STATUS.FAILED',
  PAYMENTS_CANCELLED = 'PAYMENTS.UPDATED.STATUS.CANCELLED',
  PAYMENTS_IN_PROGRESS = 'PAYMENTS.UPDATED.STATUS.IN_PROGRESS',
  PAYMENTS_RETURNED = 'PAYMENTS.UPDATED.STATUS.RETURNED',
}

export enum HyperwalletProfileTypes {
  INDIVIDUAL = 'INDIVIDUAL',
  BUSINESS = 'BUSINESS',
}

export enum VerificationStatuses {
  // Negative Statuses = Action Required
  REQUIRED = 'REQUIRED',
  FAILED = 'FAILED',

  // Positive Statuses
  VERIFIED = 'VERIFIED',
  NOT_REQUIRED = 'NOT_REQUIRED',
}
